export const queries = {
  dashboardStatus: () => ['dashboard/status'],
  assetsOwnedForReturnStatus: () => ['dashboard/status/assets/owned-for-return'],

  // Leasing
  assetsToReturnStatus: () => ['dashboard/status/assets/to-return'],
  assetsToReturnNotConnectedStatus: () => ['dashboard/status/assets/to-return/not-connected'],
  assetsPendingUserActionStatus: () => ['dashboard/status/assets/end-of-lease/pending-user-action'],
  assetsNearLeaseEndStatus: () => ['dashboard/status/assets/end-of-lease/near-lease-end'],
}
